import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef } from "react";
import Svg, { Circle, G, Mask, Path, Rect } from "react-native-svg";
import { fp, hp, spH, spV, wp } from "utils/normalise";
import { incrementnewsPopUpShownCount, setLocalNewsLetterSubscribed } from "appRedux/reducers/authSlice";
import { useDispatch, useSelector } from "react-redux";

import BottomSheetModal from "./BottomSheetModal";
import Buttons from "./Buttons";
import Carousel from "react-native-reanimated-carousel";
import Input from "./Input";
import Pagination from "./Pagination";
import { REGEX } from "utils/Constants";
import VText from "./VText";
import { newsLetterSubscribe } from "appRedux/reducers/profileSlice";
import { useGlobalSearchParams } from "expo-router";
import { useState } from "react";

const data = [
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/homepage.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/PDP.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/Outfits.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/New+Arrivals.webp",
    },
    {
        image: "https://vetirapp-images.s3.us-east-1.amazonaws.com/Outfits.webp",
    },
];

export default React.forwardRef((props, ref) => {
    const [email, setEmail] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const [isEmailError, setIsEmailError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [isSuccessModal, setIsSuccessModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const guestUserId = useSelector((state) => state.StoredutilsSlice.guestUserId);
    const userId = useSelector((state) => state.AuthReducer.userId);

    const dispatch = useDispatch();

    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();

    const global = useGlobalSearchParams();
    const gender = global?.gender || "female";

    React.useImperativeHandle(
        ref,
        () => ({
            show,
            hide,
        }),
        []
    );

    const show = () => {
        _bottomSheetRef?.current?.show();
    };

    const hide = () => {
        _bottomSheetRef?.current?.hide();
        dispatch(incrementnewsPopUpShownCount());
    };

    const checkEmailAlreadySubscribed = (email) => {
        let trimmedEmail = email?.trim();

        dispatch(newsLetterSubscribe({ emailId: trimmedEmail, justCheck: true })).then((res) => {
            if (res?.payload?.data?.data?.statusCode != 200) {
                setIsEmailError(true);
                setErrorText("You are already subscribed to our newsletter with this email.");
            }
        });
    };

    const handleInputChange = (txt) => {
        let trimmedTxt = txt?.trim();

        if (REGEX.email.test(trimmedTxt)) {
            checkEmailAlreadySubscribed(trimmedTxt);
            setIsEmailError(false);
            setErrorText("");
        } else {
            setIsEmailError(true);
            setErrorText("Please enter valid email");
        }
        setEmail(trimmedTxt);
    };

    const handleSubmit = () => {
        let trimmedEmail = email?.trim();

        if (REGEX.email.test(trimmedEmail)) {
            setIsLoading(true);
            dispatch(newsLetterSubscribe({ emailId: trimmedEmail, gender }))
                .then((res) => {
                    setIsLoading(false);
                    if (res.payload.data.data.statusCode === 200) {
                        setIsSuccessModal(true);

                        setTimeout(() => {
                            setIsSuccessModal(false);
                            hide();
                        }, 2500);

                        dispatch(setLocalNewsLetterSubscribed(true));

                        if (userId || guestUserId) {
                            dispatch(getUserDetails(userId || guestUserId));
                        }
                        setEmail("");
                    } else {
                        setErrorText("You are already subscribed to our newsletter with this email.");
                    }
                })
                .catch((err) => {
                    console.log(err);
                    setIsLoading(false);
                });
        } else {
            setIsEmailError(true);
            setErrorText("Please enter valid email");
        }
    };

    const _renderItem = ({ item, index }) => {
        const isActive = activeIndex === index;
        return (
            <Image
                source={item.image}
                accessibilityLabel={`Newsletter Image ${index + 1}`}
                style={{ width: wp(220), height: hp(330), opacity: isActive ? 1 : 0.5 }}
                resizeMode="contain"
            ></Image>
        );
    };

    return (
        <BottomSheetModal
            MAX_HEIGHT_PERC={1}
            START_PERC={1}
            ref={_bottomSheetRef}
            hideLine
            containerStyle={{
                backgroundColor: "transparent",
                zIndex: 100,
            }}
        >
            <TouchableOpacity
                style={{
                    backgroundColor: "transparent",
                    width,
                    height,
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    zIndex: 100,
                    cursor: "auto",
                }}
                activeOpacity={1}
                onPress={hide}
            >
                <TouchableOpacity
                    style={{
                        width: wp(845),
                        height: hp(466),
                        backgroundColor: "#fff",
                        overflow: "hidden",
                        cursor: "auto",
                    }}
                    activeOpacity={1}
                >
                    {isSuccessModal ? (
                        <View style={{ ...styles.successModalContainer, marginTop: hp(170) }}>
                            <View style={{ marginBottom: spV(20) }}>
                                <Image
                                    style={{ width: wp(32), height: wp(32) }}
                                    accessibilityLabel="Black Circle Check"
                                    source={require("assets/BlackCircleCheck.svg")}
                                />
                            </View>
                            <VText style={styles.aboutHeadingText}>Thank You For Signing Up</VText>
                            <VText
                                style={{
                                    ...styles.aboutSubText,
                                    fontSize: fp(16),
                                    width: wp(650),
                                    textAlign: "center",
                                }}
                            >
                                You are now subscribed to our newsletters.
                            </VText>
                        </View>
                    ) : (
                        <View
                            style={{
                                backgroundColor: "white",
                                flexDirection: "row",
                                alignItems: "center",
                                overflow: "hidden",
                            }}
                        >
                            <View
                                style={{
                                    width: wp(404),
                                    height: hp(466),
                                    backgroundColor: "black",
                                    overflow: "hidden",
                                }}
                            >
                                <View
                                    style={{
                                        marginTop: 80,
                                    }}
                                >
                                    <Carousel
                                        loop
                                        width={wp(220)}
                                        height={hp(300)}
                                        autoPlay={true}
                                        autoPlayInterval={2000}
                                        data={data}
                                        onConfigurePanGesture={(PanGesture) => {}}
                                        style={{
                                            width: wp(404),
                                            alignItems: "center",
                                            alignContent: "center",
                                            justifyContent: "center",
                                        }}
                                        mode="parallax"
                                        scrollAnimationDuration={1000}
                                        renderItem={_renderItem}
                                        onSnapToItem={(index) => setActiveIndex(index)}
                                    />
                                    <Pagination
                                        backgroundColor="white"
                                        data={Array.isArray(data) ? data : []}
                                        selectedIndex={activeIndex}
                                        thickness={8}
                                        containerStyle={{
                                            paddingVertical: 14,
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    />
                                </View>
                            </View>
                            <View
                                style={{
                                    width: wp(441),
                                    height: hp(466),
                                    paddingHorizontal: wp(30),
                                    paddingVertical: hp(40),
                                    paddingTop: hp(120),
                                }}
                            >
                                <TouchableOpacity
                                    onPress={hide}
                                    activeOpacity={0.8}
                                    style={{
                                        position: "absolute",
                                        right: 20,
                                        top: 20,
                                    }}
                                >
                                    <Svg
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <Circle cx="12" cy="12" r="12" fill="#F7F7F7" />
                                        <Path
                                            fillRule="evenodd"
                                            clipRule="evenodd"
                                            d="M11.4693 12.0006L7.75684 15.713L8.28717 16.2433L11.9996 12.5309L15.712 16.2433L16.2423 15.713L12.5299 12.0006L16.2423 8.28814L15.712 7.75781L11.9996 11.4702L8.28717 7.75781L7.75684 8.28814L11.4693 12.0006Z"
                                            fill="#212427"
                                        />
                                    </Svg>
                                </TouchableOpacity>
                                <View style={styles.aboutTextContainer}>
                                    <VText
                                        style={styles.aboutHeadingText}
                                    >{`Personalized Experience\nDelivered`}</VText>
                                    <VText style={{ ...styles.aboutSubText }}>
                                        {`Subscribe to our newsletter to get exclusive access to our latest collections, stories and videos.`}
                                    </VText>
                                    <View
                                        style={{
                                            marginTop: spV(20),
                                            alignItems: "center",
                                        }}
                                    >
                                        <Input
                                            leftIcon={() => (
                                                <View style={{ height: 27, marginRight: 10 }}>
                                                    <Svg
                                                        width="24"
                                                        height="25"
                                                        viewBox="0 0 24 25"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <Path
                                                            d="M11.9991 11.6075L21.5841 5.45C21.1987 5.16096 20.7308 5.00323 20.2491 5H3.74906C3.26736 5.00323 2.79942 5.16096 2.41406 5.45L11.9991 11.6075Z"
                                                            fill={isEmailError ? "#CE1A1A" : "#212427"}
                                                            fillOpacity={email?.length > 0 ? "1" : "0.3"}
                                                        />
                                                        <Path
                                                            d="M12.405 13.1303L12.2775 13.1903H12.2175C12.1484 13.2212 12.0751 13.2414 12 13.2503V13.2503C11.9377 13.2582 11.8748 13.2582 11.8125 13.2503H11.7525L11.625 13.1903L1.575 6.69531C1.52698 6.87647 1.50179 7.06291 1.5 7.25031V17.7503C1.5 18.347 1.73705 18.9193 2.15901 19.3413C2.58097 19.7633 3.15326 20.0003 3.75 20.0003H20.25C20.8467 20.0003 21.419 19.7633 21.841 19.3413C22.2629 18.9193 22.5 18.347 22.5 17.7503V7.25031C22.4982 7.06291 22.473 6.87647 22.425 6.69531L12.405 13.1303Z"
                                                            fill={isEmailError ? "#CE1A1A" : "#212427"}
                                                            fillOpacity={email?.length > 0 ? "1" : "0.3"}
                                                        />
                                                    </Svg>
                                                </View>
                                            )}
                                            containerStyle={{
                                                width: "100%",
                                                color: "#000000",
                                                backgroundColor: "#fff",
                                                marginBottom: hp(4),
                                            }}
                                            showIcon
                                            placeholder="Email"
                                            inputContainerStyle={{
                                                height: hp(36),

                                                borderColor:
                                                    email?.length > 0
                                                        ? isEmailError
                                                            ? "#CE1A1A"
                                                            : "#000000"
                                                        : "#00000029",
                                            }}
                                            value={email}
                                            onChangeText={handleInputChange}
                                            propStyle={{
                                                borderRadius: 0,
                                                width: "100%",
                                                color: isEmailError ? "#CE1A1A" : "#212427",
                                                fontSize: fp(12),
                                                outlineStyle: "none",
                                                fontWeight: "350",
                                            }}
                                        />
                                        {errorText && (
                                            <VText
                                                style={{
                                                    color: "#CE1A1A",
                                                    fontFamily: "JosefinSans",
                                                    textAlign: "left",
                                                    alignSelf: "flex-start",
                                                }}
                                                text={errorText}
                                            />
                                        )}
                                        <Buttons
                                            disabled={isEmailError || isLoading || email?.length === 0}
                                            containerStyle={{
                                                borderRadius: 0,
                                                width: "100%",
                                                padding: 0,
                                                marginTop: hp(16),
                                                backgroundColor:
                                                    isEmailError || isLoading || email?.length === 0
                                                        ? "#2124274D"
                                                        : "#000000",
                                                height: hp(40),
                                            }}
                                            loading={isLoading}
                                            inputContainerStyle={{
                                                height: hp(40),
                                            }}
                                            text="Subscribe"
                                            textStyle={{
                                                fontSize: fp(16),
                                                fontWeight: "350",
                                                fontFamily: "JosefinSans",
                                            }}
                                            onPress={() => {
                                                if (REGEX.email.test(email)) {
                                                    handleSubmit();
                                                } else {
                                                    setIsEmailError(true);
                                                    setErrorText("Please enter valid email");
                                                }
                                            }}
                                        />
                                    </View>
                                </View>
                            </View>
                        </View>
                    )}
                </TouchableOpacity>
            </TouchableOpacity>
        </BottomSheetModal>
    );
});

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: "rgba(240, 240, 240, 1)",
        paddingVertical: spV(48),
        paddingHorizontal: spH(60),
        flexDirection: "row",
    },
    successModalContainer: {
        flex: 1,
        alignItems: "center",
    },

    aboutTextContainer: {
        flex: 1,
    },
    aboutHeadingText: {
        fontFamily: "LibreBodoni",
        fontSize: fp(24),
        fontWeight: "300",
        textAlign: "center",
    },
    aboutSubText: {
        marginTop: spV(10),
        fontSize: fp(16),
        fontWeight: "350",
        textAlign: "center",
    },
});
